import { AuthService } from 'app/_services/auth.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { TogglePanelCallback } from 'angular/custom/components/toggle-panel.component';

class ContractingServicesComponentCtrl implements ng.IController {
    public tsoRefId: number;
    public contractingServices: ContractingServiceDto[];
    public contractingServicesEnabled: boolean;
    public isAddingNewContractingService: boolean = false;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private authService: AuthService,
        private errorHandler: ErrorHandler
    ) {}

    $onInit(): void {
        if (
            this.contractingServices.length &&
            this.contractingServices.length > 0
        ) {
            this.contractingServicesEnabled = true;
        }
    }

    public disableContractingServices(cb: TogglePanelCallback) {
        this.TransmissionSystemOperator.deleteAllContractingServices(
            { id: this.tsoRefId },
            null,
            (res) => {
                this.contractingServices = [];
                cb(true);
            },
            (err) => {
                this.errorHandler(err);
                cb(false);
            }
        );
    }

    public addNewContractingService() {
        let newContractingService: ContractingServiceDto = {
            id: null,
            serviceLabel: '',
            serviceEmail: '',
            fieldLabels: [''],
            enabled: true
        };
        this.contractingServices.push(newContractingService);
        this.isAddingNewContractingService = true;
    }

    public handleOnCreateCancel() {
        if (this.isAddingNewContractingService) {
            this.contractingServices.splice(
                this.contractingServices.length - 1,
                1
            );
            this.isAddingNewContractingService = false;
        }
    }

    public handleOnCreateSuccess() {
        this.isAddingNewContractingService = false;
    }

    public removeContractingService(index) {
        console.log('id in parent: ' + index);
        //this.contractingServices = this.contractingServices.filter(contractingService => contractingService.id != id);
        this.contractingServices.splice(index, 1);
    }
}

angular.module('app').component('pkpContractingServices', {
    controller: ContractingServicesComponentCtrl,
    template:
        require('app/operator-settings-general/contracting-services.component.html'),
    bindings: {
        contractingServices: '=',
        tsoRefId: '<'
    }
});
